export enum LOCALE {
	ENGLISH = "en",
	UKRAINIAN = "uk"
}
